import queryString from 'query-string'

export function mergeParams(
  url: string,
  params: Record<string, unknown>,
): string {
  if (!url) return ''

  const [urlWithoutQuery, query] = url?.split('?')
  const queryParams = queryString.parse(query)
  const newQuery = queryString.stringify(Object.assign(queryParams, params))

  return `${urlWithoutQuery}${newQuery ? `?${newQuery}` : ''}`
}
